var Component = require("!../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../vue-loader/lib/selector?type=script&index=0!./PrevPageLink.vue"),
  /* template */
  require("!!../../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-41ade668\"}!../../vue-loader/lib/selector?type=template&index=0!./PrevPageLink.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/primevue/paginator/PrevPageLink.vue
// module id = 1986
// module chunks = 0